import { AssetManager } from 'components/sharpr/assetManager/AssetManager';

export function QuestionPhraseListingRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.QuestionPhraseListing', {
		url: '/admin/question_phrases',
		controllerAs: 'vm',
		controller: QuestionPhraseListingCtrl,
		templateUrl: '/ng/hub/QuestionPhrase/Listing/QuestionPhraseListingCtrl.html?' + window.BUILD,
		permission: ['all'],
		resolve: {
			style: () => AssetManager.css('/ng/hub/QuestionPhrase/Listing/QuestionPhraseListingCtrl.css'),
			$title: () => 'Question Phrases',
		},
	});
}

export class QuestionPhraseListingCtrl {
	constructor() {
		'ngInject';
		this.table = {
			filters: {
				term: '',
			},
			columns: [
				{ field: 'id', label: 'ID', sortable: false },
				{ field: 'pattern', label: 'Pattern', sortable: false },
			],
			bindUrl: 'search',
		};
	}
}
